const extractPluginsConfig = (plugins) => {
  let mergedConfig = {};
  plugins?.forEach((plugin) => {
    const { type, ...rest } = plugin;
    const config = "config" in plugin ? plugin.config : rest;
    if (config && Object.keys(config).length !== 0) {
      mergedConfig = { ...mergedConfig, [type]: config };
    }
  });
  return { config: mergedConfig };
};
export {
  extractPluginsConfig
};
//# sourceMappingURL=extract-plugins-config.js.map
